import { USER_ROLE } from "../constants/user";

export const isNotOperator = (role: any): boolean => {
  return !role.includes(USER_ROLE.OPERATOR);
};
